const formatNumber = (_number: number, _separator?: string, _decimal?: number) : string => {
    const decimal = _decimal || 0;
    const separator = _separator || ' ';
    let r = _number;
    const exp10 = 10 ** decimal;

    r = Math.round(r * exp10) / exp10;

    const rr = Number(r).toFixed(decimal).toString().split('.');
    const b = rr[0].replace(/(\d{1,3}(?=(\d{3})+(?:\.\d|\b)))/g, `$1${separator}`);

    return (rr[1] ? `${b}.${rr[1]}` : b);
};

export default formatNumber;
